/**
 * ドロワーメニュー
 */
export default class DrawerMenu extends HTMLElement {

  constructor() {
    super();

    // 各種要素の取得
    this.drawerMenu = this.querySelector("[data-target-id=drawer-menu]")
    this.openButton = this.querySelectorAll("[data-target-id=drawer-open-button]");
    this.closeButton = this.querySelector("[data-target-id=drawer-close-button]");

    // イベント登録
    this.initDrawerMenu();
  }

  /**
   * ドロワーメニュー開閉のイベント登録
   */
  initDrawerMenu() {
    this.openButton.forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        this.drawerMenu.classList.add("-is-show");
      });
    });
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.drawerMenu.classList.remove("-is-show");
    });

    // 画面外をクリックでドロワーメニューを閉じる
    this.addEventListener("click", (e) => {
      if (this.drawerMenu.classList.contains("-is-show") && !this.drawerMenu.contains(e.target)) {
        this.drawerMenu.classList.remove("-is-show");
      }
    }, true);
  }
}